import React from "react";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import myOrdersApi from "../../apis/api/MyOders";
import CourseCard from "../../components/TopCourses/CourseCard/CourseCard";
import Box from "@mui/material/Box";
import { Navigate, Link } from "react-router-dom";
import Loading from "../../components/Loader";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import "./myCourse.css";

function MyCourses() {
  const [course, setCourse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [courseOnly, setCourseOnly] = useState([]);
  const [eventsOnly, setEventsOnly] = useState([]);
  useEffect(() => {
    myCourse();
  }, []);
  const myCourse = async() => {
    let data = await myOrdersApi(setCourse, setLoading, setError);
    if(data){
      setCourseOnly(data.filter(item => {
        return item.course_type === "course";
      }))
      setEventsOnly(data.filter(item => {
        return item.course_type === "event";
      }))
    }
  }
  let { admin, isLogin } = useSelector((state) => state.AuthReducer);
  return (
    <>
      {isLogin ?  
      <div style={{ placeContent: "center" }}>
        <Box
          component="section"
          className="page-heading"
          sx={{
            background: `url(https://tv-academy-assets.s3.eu-west-2.amazonaws.com/My+courses.jpg)`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div className="course-container">
            {/* <img src={BlogHead1} alt="" width="15" /> */}
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">
                  Home
                  <div className="line"></div>
                </li>
                <li className="breadcrumb-item active">My Courses</li>
              </ol>
            </nav>
            <h1 className="event-heading">My Courses</h1>
          </div>
        </Box>
        {loading ? (
          <Loading />
        ) : course.length === 0 ? (
          <Box sx={{ p: 2, mb: 15, mt: 15, textAlignLast: "center" }}>
            <h5>
              {" "}
              <span style={{ fontWeight: "bolder" }}>No Courses!!!</span> Go to{" "}
              <Link to="/all-courses/all">Marketplace</Link> and get some
              courses.
            </h5>
          </Box>
        ) : (
          <>
            {error ? (
              <Navigate to="/404" />
            ) : (
              <>
                <Container maxWidth="lg" sx={{ p: 2 }}>
                  {courseOnly.length > 0 && <Typography variant="h4" component="h4">Course</Typography>}
                  <Grid container spacing={3}>
                    {course &&
                      course.map((data, index) => (
                        <Grid item>
                          {data.course_type === "course" &&
                            <CourseCard
                              key={index}
                              id={data.course_id}
                              title={data.course_name}
                              pic={data.course_image}
                              noOfReviews={data.reviews}
                              courseType={data.course_type}
                              gradient={data.gradient}
                              price={data.price}
                              eventDate={data.event_date}
                              // discount,
                              rating={data.avg_rating}
                              //couseData={data}
                              fromMycourse={true}
                              // review={data.reviews}
                            ></CourseCard>}
                        </Grid>
                      ))}
                  </Grid>
                </Container>
                <Container maxWidth="lg" sx={{ p:2 }}>
                {eventsOnly.length > 0 && <Typography variant="h4" component="h4">Events</Typography>}
                  <Grid container spacing={3}>
                    {course &&
                      course.map((data, index) => (
                        
                        <Grid item sx={{paddingLeft: '16px !important'}}>
                          {data.course_type === "event" &&
                            <CourseCard
                              key={index}
                              id={data.event_id}
                              title={data.event_name}
                              pic={data.event_image}
                              noOfReviews={data.reviews}
                              courseType={data.course_type}
                              gradient={data.gradient}
                              price={data.price}
                              eventDate={data.event_date}
                              // discount,
                              rating={data.avg_rating}
                              //couseData={data}
                              fromMycourse={true}
                              // review={data.reviews}
                            ></CourseCard>}
                        </Grid>
                      ))}
                  </Grid>
                </Container>
              </>
            )}
          </>
        )}
      </div>:
        <Navigate to="/" />
      }
    </>
  );
}

export default MyCourses;
